import React from "react";
import Reveal from "./Reveal";

/**
 * The Manifesto — long-form editorial vision statement, dark section.
 * Anthropic / Stripe / OpenAI use this exact pattern: a quiet, confident essay
 * that signals depth of thinking and a clear point of view.
 */
export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="section-dark relative overflow-hidden"
      data-testid="manifesto-section"
    >
      <span
        className="orb"
        style={{ width: 420, height: 420, top: -150, left: "-6%", background: "#4F46E5", opacity: 0.32 }}
        aria-hidden="true"
      />
      <span
        className="orb"
        style={{ width: 360, height: 360, bottom: -120, right: "-6%", background: "#C9A961", opacity: 0.22 }}
        aria-hidden="true"
      />

      <div className="container-edge relative py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="mono-label-gold">THE MANIFESTO</p>
            </Reveal>
            <Reveal delay={100}>
              <h2
                className="mt-5 font-display text-[32px] md:text-[40px] lg:text-[46px] leading-[1.05] tracking-tight"
                style={{ fontWeight: 400, color: "var(--canvas)" }}
              >
                We don't believe in the AI gap.
                <br />
                <em className="italic" style={{ fontWeight: 400, color: "var(--accent-gold)" }}>
                  We close it.
                </em>
              </h2>
            </Reveal>
            <Reveal delay={180}>
              <p
                className="mt-6 font-mono text-[11px]"
                style={{ color: "rgba(250,250,247,0.55)", letterSpacing: "0.18em" }}
              >
                MAY 2026 · KOLKATA · WORLDWIDE
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8 space-y-5">
            <Reveal delay={140}>
              <p
                className="font-display text-[20px] md:text-[24px] leading-[1.45]"
                style={{ fontWeight: 400, color: "rgba(250,250,247,0.95)" }}
              >
                The internet shift took ten years. The mobile shift took five.
                <em className="italic"> The AI shift is taking eighteen months.</em>
              </p>
            </Reveal>

            <Reveal delay={220}>
              <p
                className="text-[15px] md:text-[17px] leading-[1.7]"
                style={{ color: "rgba(250,250,247,0.78)" }}
              >
                We don't teach AI as theory — we train practitioners who ship. We don't end with
                a certificate — we end with a product. We mentor cohorts through the Innovation
                Arena, place them through the AI Jobs marketplace, and back the strongest into
                companies of their own.
                <span style={{ color: "var(--canvas)" }}>
                  &nbsp;Learn, Build, Hire, Invest is not a tagline. It is the operating system.
                </span>
              </p>
            </Reveal>

            <Reveal delay={300}>
              <p
                className="font-display italic text-[20px] md:text-[24px] leading-[1.3] pt-1"
                style={{ fontWeight: 400, color: "var(--accent-gold)" }}
              >
                "Built in India. Made for the world. Open to anyone willing to ship."
              </p>
            </Reveal>

            <Reveal delay={380}>
              <p
                className="mt-1 font-mono text-[11px]"
                style={{ color: "rgba(250,250,247,0.55)", letterSpacing: "0.18em" }}
              >
                — SOUMOJIT DAS · FOUNDER, AI FOR EVERYONE
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
